import type { UrlParams } from 'utils/url'

const SALABLE_CUSTOMER_CODE = '_sa_'
const ACCEPTED_CUSTOMER_CODE = '_ac_'
const ABORTED_CUSTOMER_CODE = '_ab_'
const DAC_COMPLETED_CODE = '_ab_dac_'

export interface RceCustomerCategory {
  isSalableCustomer: boolean
  isAcceptedCustomer: boolean
  isAbortedCustomer: boolean
  isAbortedDacCompleteCustomer: boolean
}

interface RceCustomerCategorySource extends Pick<UrlParams, 'utm_campaign'> {
  parentUrl?: string
}

const getParentUtmCampaign = (parentUrl?: string): string | undefined => {
  if (!parentUrl) return undefined

  try {
    return new URL(parentUrl).searchParams.get('utm_campaign') || undefined
  } catch {
    return undefined
  }
}

export const getRceCustomerCategory = ({
  utm_campaign: localUtmCampaign,
  parentUrl
}: RceCustomerCategorySource): RceCustomerCategory => {
  const utmCampaign = localUtmCampaign || getParentUtmCampaign(parentUrl)

  return {
    isSalableCustomer: utmCampaign?.includes(SALABLE_CUSTOMER_CODE) ?? false,
    isAcceptedCustomer: utmCampaign?.includes(ACCEPTED_CUSTOMER_CODE) ?? false,
    isAbortedCustomer: utmCampaign?.includes(ABORTED_CUSTOMER_CODE) ?? false,
    isAbortedDacCompleteCustomer:
      utmCampaign?.includes(DAC_COMPLETED_CODE) ?? false
  }
}
